import BaseWidget from "common/widgets/base/BaseWidget";
import accessible from "common/managers/accessible";
import locale from "common/managers/locale";
import virtualConstants from "common/helper/virtualConstants";
import AccessibleMode from "app/widgets/DFMultiSelect/DFMultiSelectAccessibleMode";
import popupUtils from "app/widgets/Popup/popupUtils";
import DFButton from "app/widgets/DFButton/DFButton";

if (!kendo.data.binders.widget.dfmultiselect) {
    kendo.data.binders.widget.dfmultiselect = {};
}

kendo.data.binders.widget.dfmultiselect.value = kendo.data.binders.widget.multiselect.value;

const DFMultiSelect = BaseWidget(kendo.ui.MultiSelect).extend(AccessibleMode).extend({

    _readonlyCache: false,
    _enableCache: true,

    options: {
        name: "DFMultiSelect",
        placeholderKey: "",
        selectAll: false,
        clearButton: false,

        //Is accessible mode possible on this control.
        //Not all features of DFMultiSelect are supported so this is not just enabled by default. It must be tested.
        accessibleMode: false,

        // default height of multiselect for virtualization
        height: virtualConstants.height
    },

    init: function(element, options) {
        this._setNativeSize = this._setNativeSize.bind(this);
        if (options.placeholderKey !== "") {
            options.placeholder = locale.get(options.placeholderKey);
        }

        if (options.virtual && !options.virtual.itemHeight) {
            options.virtual.itemHeight = virtualConstants.itemHeight;
        }

        if (options.selectAll) {
            options.headerTemplate = `<div><button class="selectAll primary">${locale.get("select.all")}</button></div>`;
        }

        kendo.ui.MultiSelect.fn.init.apply(this, arguments);
        this.list.parent().addClass("DFMultiSelectPopup");
        this._bindDataToSize();

        var id = this.element.attr("id");
        if (!id) {
            console.error("DFMultiSelect widget requires an id");
        }

        if (!this.element.attr("name")) {
            this.element.attr("name", id);
        }

        if (options.selectAll) {
            new DFButton(this.popup.element.find("button.selectAll"), {
                click: () => {
                    const other = this.dataSource.view().map((item) => {
                        return item[this.options.dataValueField];
                    });
                    this.value(other);
                    this.trigger("change");
                    this.close();
                }
            });
            const toggleHeader = () => {
                this.header.toggle(this.dataSource.total() > 0);
            };
            this.dataSource.bind("change", toggleHeader);
            toggleHeader();
        }

        this.initAccessibleMode();

        this.bind("open", () => {
            popupUtils.configurePopup(this.wrapper[0], this.popup, virtualConstants.height);
        });
    },

    destroy: function() {
        this.unbind("change");
        this.element.off();
        kendo.ui.MultiSelect.fn.destroy.apply(this, arguments);
    },

    setDataSource(dataSource) {
        this.dataSource.unbind("change", this._setNativeSize);
        kendo.ui.MultiSelect.fn.setDataSource.apply(this, arguments);
        this._bindDataToSize()
    },

    _bindDataToSize() {
        this._setNativeSize();
        this.dataSource.bind("change", this._setNativeSize);
    },

    getARIAElements: function() {
        return this.element.add(this.input);
    },

    valueForValidation: function() {
        return this.value().join(",");
    },

    /**
     * Need to have special focus handling for the native select in accessibility mode
     */
    focus: function() {
        if (!accessible.isInAccessibleMode()) {
            return kendo.ui.MultiSelect.fn.focus.apply(this, arguments);
        }
        this.element.focus();
    },

    readonly(readonly) {
        this._readonlyCache = readonly === undefined ? true : readonly;
        this.wrapper.toggleClass("readonly", this._readonlyCache);
        this._editable({
            readonly: this._readonlyCache,
            disable: !this._enableCache
        });
        this.input.add(this.element).attr("tabindex", this._readonlyCache ? "-1" : "0");
    },

    enable(enable) {
        this._enableCache = enable === undefined ? true : enable;
        this._editable({
            readonly: this._readonlyCache,
            disable: !this._enableCache
        });
    }
});

kendo.ui.plugin(DFMultiSelect);
export default DFMultiSelect;
